module.exports = __webpack_public_path__ + "img/logo.b63c79d2.png";